import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { capitalizeFirstLetter, formateDateWithMonth, formateDateWithMonthAdmin, showStatus } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import Breadcrums from "../../../common/breadcrumbs";
import * as productManagement from "../../../services/productManagement";
import toHtml from "html-react-parser";

const ViewCategories = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: t("categories"),
            url: "/admin/productManagement/categories/list/1",
        },
        { title: t("btn_view"), url: "" },
    ];

    useEffect(() => {
        console.log(params.id)
        productManagement
            .Details(params.id)
            .then((response) => {
                console.log("View response-", response);
                setShowDefault(response && response.data ? response.data : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">
                                    {t('View Category')}
                                </h6>
                            </div>
                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>

                                                <tr>
                                                    <th>{t("label_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.title
                                                            ? capitalizeFirstLetter(showdefault.title)
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_description")}</th>
                                                    <td>
                                                        {showdefault && showdefault.description
                                                            ? capitalizeFirstLetter(showdefault.description)
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("list_heading_status")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.status === 0
                                                            ? toHtml(showStatus(showdefault.status))
                                                            : toHtml(showStatus(showdefault.status))}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_image")}</th>
                                                    <td><img src={showdefault && showdefault.image ? showdefault.image : ""} alt={showdefault?.title} style={{ height: "100px" }} /></td>
                                                </tr>
                                                <tr>
                                                    <th>{t("list_heading_created_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.createdAt
                                                            ? formateDateWithMonthAdmin(showdefault.createdAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                  {/* <tr>
                                                    <th>{t("list_heading_icon")}</th>
                                                    <td>
                                                        {showdefault && showdefault.icon
                                                            ? showdefault.icon
                                                            : "N/A"}
                                                    </td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            )}
                        </div>
                        

                        <div className="mt-5 back-button">
                            <button
                                className="btn ripple btn-dark"
                                type="button"
                                onClick={() =>
                                    navigate("/admin/productManagement/categories/list/1")
                                }
                            >
                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                {t("btn_back")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewCategories;
